/* unplugin-vue-components disabled */import script from "./DqlyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./DqlyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./DqlyDetail.vue?vue&type=style&index=0&id=5efc2547&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5efc2547"]])

export default __exports__